import { OpenAPI } from './generated/requests/core/OpenAPI';
import { AuthService } from '../services/authService';
import { KeycloakService } from '../services/keycloakService';
import axios from "axios";

// Konfiguracja OpenAPI
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
OpenAPI.BASE = API_URL;

// Dodanie uwierzytelniania do zapytań OpenAPI
OpenAPI.WITH_CREDENTIALS = true;

// Utworzenie wspólnego klienta axios
const apiClient = AuthService.createAuthenticatedClient(API_URL);

// Dodanie obsługi CORS
apiClient.defaults.withCredentials = true;

// Interceptor do obsługi błędów
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Jeśli błąd autoryzacji (401), próbujemy odświeżyć token
    if (error.response && error.response.status === 401) {
      // Sprawdzenie czy jesteśmy zalogowani w Keycloak
      if (KeycloakService.isLoggedIn()) {
        return KeycloakService.updateToken()
          .then(() => {
            // Powtórzenie pierwotnego żądania z nowym tokenem
            error.config.headers['Authorization'] = `Bearer ${AuthService.getToken()}`;
            return axios(error.config);
          })
          .catch(() => {
            // Jeśli nie udało się odświeżyć tokenu, wyloguj użytkownika
            KeycloakService.login();
            return Promise.reject(error);
          });
      }
    }
    return Promise.reject(error);
  }
);

// Konfiguracja interceptorów, używając właściwej struktury dla axios
axios.interceptors.request.use(async (config) => {
  // Sprawdzenie i ewentualne odświeżenie tokenu
  if (KeycloakService.isLoggedIn()) {
    try {
      await KeycloakService.updateToken(60); // Odśwież token jeśli wygaśnie w ciągu 60 sekund
    } catch (error) {
      console.error('Nie udało się odświeżyć tokenu:', error);
    }
  }

  // Dodanie tokenów autoryzacyjnych
  const token = AuthService.getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

// Eksport konfiguracji
export { OpenAPI, apiClient };
